import React from 'react';

import {useWritableContext} from 'insights/WritableContext';
import {ButtonSize} from 'ui-library/buttons/Button';
import UIPlaceholder from 'ui-library/UIPlaceholder';

import AddBlockToDashboardButton, {AddBlockToDashboardButtonProps} from './AddBlockToDashboardButton';

type AnalyticsDashboardNoBlocksContentProps = Omit<AddBlockToDashboardButtonProps, 'buttonProps'>;

export default function AnalyticsDashboardNoBlocksContent(
  props: AnalyticsDashboardNoBlocksContentProps
): JSX.Element {
  const writable = useWritableContext();

  return (
    <UIPlaceholder
      infoSection="This dashboard doesn't have any blocks."
      actionContent={
        writable ? (
          <AddBlockToDashboardButton {...props} buttonProps={{size: ButtonSize.MEDIUM}} />
        ) : undefined
      }
    />
  );
}
